import styled from 'styled-components';

export const LoadingWrapper = styled.div.attrs({
	role: 'status',
	'aria-label': 'loading',
})`
	text-align: center;
`;
LoadingWrapper.displayName = 'LoadingWrapper';
